<!-- dialog content can either be in the content parameter or in the slot -->
@if (pagelet()?.stringParam('Content')) {
<div [ishServerHtml]="pagelet().stringParam('Content')" data-testing-id="dialog-content"></div>
}

<ish-content-slot [slot]="'app_sf_base_cm:slot.dialog.content.pagelet2-Slot'" [pagelet]="pagelet()" />
